import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-fullservicepricingtype-dropdown',
  templateUrl: './FullServicePricingTypeDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => FullServicePricingTypeDropdownComponent)}]
})
export class FullServicePricingTypeDropdownComponent extends BaseDropdownComponent {

   
    constructor(private domainDataService: serv.DomainDataService) 
    { 
        super();
    }


    ngOnInit(): void {
    }

    public load(){
        this.domainDataService.getFullServicePricingTypes().subscribe(x=> this.onGetFullServicePricingTypesDone(x));
    }
    
    onGetFullServicePricingTypesDone(items: ent.FullServicePricingType[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        this.value = this.selectedID;
    }

}